/* tslint:disable */
/* eslint-disable */
/**
 * Employees API
 * API to get company clients employees
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyClientReviewLabelApplicationKind,
    CompanyClientReviewLabelApplicationKindFromJSON,
    CompanyClientReviewLabelApplicationKindFromJSONTyped,
    CompanyClientReviewLabelApplicationKindToJSON,
} from './CompanyClientReviewLabelApplicationKind';

/**
 * 
 * @export
 * @interface CompanyClientReviewLabelOfEmployee
 */
export interface CompanyClientReviewLabelOfEmployee {
    /**
     * Label ID
     * @type {number}
     * @memberof CompanyClientReviewLabelOfEmployee
     */
    labelId: number;
    /**
     * Count of how much times this label was selected
     * @type {number}
     * @memberof CompanyClientReviewLabelOfEmployee
     */
    labelCount?: number;
    /**
     * A skill the employee is good at or can improve on
     * @type {string}
     * @memberof CompanyClientReviewLabelOfEmployee
     */
    description?: string;
    /**
     * 
     * @type {CompanyClientReviewLabelApplicationKind}
     * @memberof CompanyClientReviewLabelOfEmployee
     */
    labelAppKind: CompanyClientReviewLabelApplicationKind;
}

export function CompanyClientReviewLabelOfEmployeeFromJSON(json: any): CompanyClientReviewLabelOfEmployee {
    return CompanyClientReviewLabelOfEmployeeFromJSONTyped(json, false);
}

export function CompanyClientReviewLabelOfEmployeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyClientReviewLabelOfEmployee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'labelId': json['labelId'],
        'labelCount': !exists(json, 'labelCount') ? undefined : json['labelCount'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'labelAppKind': CompanyClientReviewLabelApplicationKindFromJSON(json['labelAppKind']),
    };
}

export function CompanyClientReviewLabelOfEmployeeToJSON(value?: CompanyClientReviewLabelOfEmployee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'labelId': value.labelId,
        'labelCount': value.labelCount,
        'description': value.description,
        'labelAppKind': CompanyClientReviewLabelApplicationKindToJSON(value.labelAppKind),
    };
}

